import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage } from '../../validation/validationError';
import { Loader } from '../../components/ModalsCommonFunctions';

const SectionStudyMaterialShow = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        gradeName: '',
        divisionName: ''
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [studyData, setStudyData] = useState(initialFormState);

    const [studyStatusData, setStudyStatusData] = useState([]);
    const [errors, setErrors] = useState([]);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
    }, []);

    useEffect(() => {
        studyMaterialStatus();
    }, [studyData.instituteGradeMasterId, studyData.instituteDivisionMasterId, divisionList])

    const studyMaterialStatus = async () => {
        if (studyData.instituteGradeMasterId !== "" && studyData.instituteGradeMasterId !== null) {
            let apiUrl = `/get-study-material-show?sectionMasterId=${sectionMasterId}&`;
            if (studyData.instituteGradeMasterId) {
                apiUrl += `instituteGradeMasterId=${studyData.instituteGradeMasterId}&`;
            }
            if (studyData.instituteDivisionMasterId) {
                apiUrl += `instituteDivisionMasterId=${studyData.instituteDivisionMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            try {
                const response = await authorizedAxiosSection.get(apiUrl);
                const responseData = response.data.result;

                if (studyData.instituteDivisionMasterId !== '' && studyData.instituteDivisionMasterId !== null) {
                    if (responseData.length == 0) {
                        setStudyStatusData([{
                            status: "Y",
                            sectionMasterId,
                            instituteGradeMasterId: studyData.instituteGradeMasterId,
                            instituteDivisionMasterId: studyData.instituteDivisionMasterId,
                            instituteGradeMasterDetails: {
                                id: studyData.instituteGradeMasterId,
                                gradeName: studyData.gradeName
                            },
                            instituteDivisionMasterDetails: {
                                id: studyData.instituteDivisionMasterId,
                                divisionName: studyData.divisionName
                            }
                        }]);
                    } else {
                        setStudyStatusData(responseData);
                    }
                } else {
                    const myObject = {};
                    responseData.forEach(item => {
                        myObject[item.instituteDivisionMasterId] = item;
                    });

                    const statuses = [];
                    divisionList.forEach(division => {
                        if (division.id in myObject) {
                            statuses.push(myObject[division.id]);
                        } else {
                            statuses.push({
                                status: "Y",
                                sectionMasterId,
                                instituteGradeMasterId: studyData.instituteGradeMasterId,
                                instituteDivisionMasterId: division.id,
                                instituteGradeMasterDetails: {
                                    id: studyData.instituteGradeMasterId,
                                    gradeName: studyData.gradeName
                                },
                                instituteDivisionMasterDetails: {
                                    id: division.id,
                                    divisionName: division.divisionName
                                }
                            });
                        }
                    });

                    setStudyStatusData(statuses);
                }
            } catch (error) {
                setStudyStatusData([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    };


    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;

        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleGradeChange = async (e) => {
        const { name, value } = e.target;
        const selectedGradeName = e.target.options[e.target.selectedIndex].getAttribute('data-grade-name');
        setStudyData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                gradeName: selectedGradeName,
                instituteDivisionMasterId: '',
                divisionName: ''
            }
        })

        const apiUrl = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setDivisionList(response.data.result)
            // await studyMaterialStatus();
        } catch (error) {
            setDivisionList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleDivisionChange = (e) => {
        const { name, value } = e.target;
        const selectedDivisionName = e.target.options[e.target.selectedIndex].getAttribute('data-division-name');
        setStudyData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                divisionName: selectedDivisionName
            }
        })

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const changeActive = async (sectionMasterId, instituteGradeMasterId, instituteDivisionMasterId, status, id) => {
        setLoading(true);
        const apiUrl = `/add-edit-study-material-show`;
        try {
            await authorizedAxiosSection.post(apiUrl, { id, sectionMasterId, instituteGradeMasterId, instituteDivisionMasterId, status });
            await studyMaterialStatus();
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    // const changeActive = async (id, sectionMasterId, instituteGradeMasterId, instituteDivisionMasterId, status) => {
    //     setLoading(true);
    //     const apiUrl = `/add-edit-study-material-show`;
    //     try {
    //         await authorizedAxiosSection.post(apiUrl, {id, sectionMasterId, instituteGradeMasterId, instituteDivisionMasterId, status});
    //         await studyMaterialStatus();
    //     } catch (error) {
    //         const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //         Swal.fire(
    //             { text: errorMsg }
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    const handleInputReset = () => {
        setStudyData(initialFormState);
        setStudyStatusData([]);
        setDivisionList([]);
        setErrors([]);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Study Material Show</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-book"></i>Study Material Show</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="instituteGradeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class:</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studyData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id} data-grade-name={grade.gradeName}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="instituteGradeMasterId" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="instituteDivisionMasterId" className="col-form-label">Select Division:</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleDivisionChange} value={studyData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id} data-division-name={division.divisionName}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="instituteDivisionMasterId" />
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {/* <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={showReport}>Show</button> */}
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">Division</th>
                                                                        <th scope="col">Status</th>
                                                                        <th scope="col">Active/Inactive</th>
                                                                        {/* <th scope="col">Action</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        studyStatusData?.length > 0 ?
                                                                            studyStatusData?.map((data, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{data.instituteGradeMasterDetails.gradeName}</td>
                                                                                        <td>{data.instituteDivisionMasterDetails.divisionName}</td>
                                                                                        <td>{(data.status == 'Y') ? 'Actived' : 'Inactivated'}</td>
                                                                                        <td>
                                                                                            <div className={`toggle-container ${data.status == 'Y' ? 'active' : ''}`} onClick={() => changeActive(data.sectionMasterId, data.instituteGradeMasterId, data.instituteDivisionMasterId, data.status == 'Y' ? 'N' : 'Y', data.id)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                        {/* <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => delete(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td> */}
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Status Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionStudyMaterialShow;